// React
import { useContext, useEffect, useRef, useState } from "react";

// @mui material components
import { Card, Collapse, Icon, Menu, MenuItem, Select, Skeleton, Tooltip, Modal, Fade } from "@mui/material";

import { gql, useLazyQuery, useMutation, useQuery, useSubscription } from "@apollo/client";
import Loading from "components/Carteles/Loading";
import SinDatos from "components/Carteles/SinDatos";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import ModalConfirm from "components/Modals/ConfirmMsg";
import ModalOptions from "components/Modals/Options";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import CustomPagination from "components/Pagination";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import DataTable from "components/Tables/DataTable";
import { MessageManager } from "context";
import { getUproColor } from "utils/colors";
import ModalAjuste from "./components/ModalAjustes";
import ModalAjusteHistory from "./components/ModalAjustes/ModalHistorial";
import ModalProducto from "./components/ModalProducto";
import ModalProductoMovimientos from "./components/ModalProductoMovimientos";
import ModalProductoStock from "./components/ModalProductoStock";
import Table from "components/Tables/Table";

//REMITO SEDE

import { MenuContext } from "context/menuContext";
import { UserContext } from "context/user";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import ModalStockRapido from "./components/ModalStockRapido";
import productoData from "./data/productoData";
import ModalNuevoRemito from "./components/ModalIngresar/ModalNuevoRemito";
import ModalIngresar from "./components/ModalIngresar";
import ModalProveedores from "./components/ModalProveedores";
import ModalNuevaTransferencia from "./components/ModalTransferencia";
import ModalHistorialTransferencias from "./components/ModalTransferencia/ModalHistorial";
import ModalProductoComercial from "layouts/productos/ModalComerciales";
import DrawerProductoDetalle from "./components/DrawerProductoDetalle";

const NUEVO_PEDIDO_STOCK_SUBSCRIPTION = gql`
  subscription materiaPrimaNuevoPedidoStock {
    nuevoPedido {
      id
      updatedAt
    }
  }
`;

const PEDIDO_MODIFICADO_STOCK_SUBSCRIPTION = gql`
  subscription materiaPrimaPedidoModificadoStock {
    pedidoModificado {
      id
      updatedAt
    }
  }
`;

const PEDIDO_ELIMINADO_STOCK_SUBSCRIPTION = gql`
  subscription materiaPrimaPedidoEliminadoStock {
    pedidoEliminado {
      id
      updatedAt
    }
  }
`;

function Productos() {
  const { columns, getRows } = productoData;
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [openFilters, setOpenFilters] = useState(false);
  const [page, setPage] = useState(1);
  const [pagesInfo, setPagesInfo] = useState({
    pages: 0,
    total: 0,
  });
  const [orderBy, setOrderBy] = useState({
    campo: "id",
    orden: "DESC",
  });
  const [filter, setFilter] = useState({
    disabled: false,
  });
  const [selectedSucursal, setSelectedSucursal] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openDetailDrawer, setOpenDetailDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState();
  const { handleSnackbar } = useContext(MessageManager);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [openModalProducto, setOpenModalProducto] = useState(false);
  const [openIngresoMenu, setOpenIngresoMenu] = useState(false);
  const [openModalNuevoRemito, setOpenModalNuevoRemito] = useState(false);
  const [openModalIngresar, setOpenModalIngresar] = useState(false);
  const [openModalProductoMovimientos, setOpenModalProductoMovimientos] = useState(false);
  const [openModalProductoStock, setOpenModalProductoStock] = useState(false);
  const [openModalAjuste, setOpenModalAjuste] = useState(false);
  const [selectedAjuste, setSelectedAjuste] = useState();
  const [openAddMenu, setOpenAddMenu] = useState(false);
  const [openAjusteMenu, setOpenAjusteMenu] = useState(false);
  const [openSucursalMenu, setOpenSucursalMenu] = useState(false);
  const [openModalProveedores, setOpenModalProveedores] = useState(false);
  const [openModalTransferencia, setOpenModalTransferencia] = useState(false);
  const [openModalTransferenciaHistory, setOpenModalTransferenciaHistory] = useState(false);
  const [openModalShowProductos, setOpenModalShowProductos] = useState(false);
  const [productosNombres, setProductosNombres] = useState([]);
  const [openModalAjusteHistory, setOpenModalAjusteHistory] = useState(false);
  const [openModalOptions, setOpenModalOptions] = useState(false);
  const { user } = useContext(UserContext);
  const [openModalStockRapido, setOpenModalStockRapido] = useState(false);
  const [openModalProdComercial, setOpenModalProdComercial] = useState(false);
  const { menu } = useContext(MenuContext);
  const stockRefreshTimeoutRef = useRef(null);
  // Filtro local: mostrar solo materias con provisiones pendientes
  const [onlyPendiente, setOnlyPendiente] = useState(false);

  const { data: nuevoPedidoStockEvent } = useSubscription(NUEVO_PEDIDO_STOCK_SUBSCRIPTION);
  const { data: pedidoModificadoStockEvent } = useSubscription(
    PEDIDO_MODIFICADO_STOCK_SUBSCRIPTION
  );
  const { data: pedidoEliminadoStockEvent } = useSubscription(
    PEDIDO_ELIMINADO_STOCK_SUBSCRIPTION
  );

  const { data: dataSucurales, loading: loadingSucursales } = useQuery(
    gql`
      query getSucursales($filter: JSON) {
        sucursales(filter: $filter) {
          id
          nombre
          sede {
            id
            nombre
          }
          administraStock
          principal
        }
      }
    `,
    {
      variables: {
        filter: {
          administraStock: true,
          id: user?.sucursales ? user?.sucursales.map((sucursal) => sucursal.id) : undefined,
        },
      },
      onCompleted: (data) => {
        if (data?.sucursales?.length > 0) {
          setSelectedSucursal(data?.sucursales[0].id);
        }
      },
    }
  );

  const { data: dataCategorias } = useQuery(
    gql`
      query categoriasMateriaPrima {
        categoriasMateriaPrima {
          tipoProducto
          nombre
        }
      }
    `
  );

  const { loading, data, refetch } = useQuery(
    gql`
      query getProductos(
        $search: String
        $page: Int
        $order: Order
        $filter: JSON
        $idSucursal: ID
      ) {
        paginationInfo {
          pages
          total
        }
        materiasPrimas(
          search: $search
          pagination: { page: $page, limit: 10 }
          order: $order
          filter: $filter
        ) {
          id
          codigo
          tipo
          nombre
          disabled
          categoria
          motivoBaja
          porcentajeUtilizable
          precio
          pendienteRecepcionar
          ingredientes {
            id
            producto {
              id
              nombre
            }
          }
          tipoUnidad {
            id
            nombre
            abreviatura
            multiplicador
          }
          stock(idSucursal: $idSucursal) {
            cantidad
            enPrestamo
            reservado
            disponible
            pasillo
            fila
            columna
            stockMinimo
          }
        }
      }
    `,
    {
      variables: {
        search: search || null,
        page: page,
        order: { field: orderBy.campo, order: orderBy.orden },
        filter: {
          ...filter,
          //Si filter.tipo es -1, añadir que el tipo sea "Materia", "Consumible" o "Recurso"
          tipo: filter?.tipo == undefined ? ["Material", "Consumible", "Recurso"] : filter?.tipo,
        },
        idSucursal: selectedSucursal || null,
      },
      fetchPolicy: "no-cache",
    }
  );

  const [getProductosData] = useLazyQuery(
    gql`
      query getProductos($order: Order, $filter: JSON, $idSucursal: ID) {
        materiasPrimas(order: $order, filter: $filter) {
          __typename @skip(if: true)
          id
          tipo
          nombre
          disabled
          categoria
          pendienteRecepcionar
          stock(idSucursal: $idSucursal) {
            cantidad
            enPrestamo
            reservado
            disponible
            pasillo
            fila
            columna
            stockMinimo
          }
        }
      }
    `
  );

  const [getProductosSede] = useLazyQuery(
    gql`
      query getProductos($order: Order, $filter: JSON, $idSede: ID) {
        materiasPrimas(order: $order, filter: $filter) {
          __typename @skip(if: true)
          id
          tipo
          nombre
          disabled
          categoria
          pendienteRecepcionar
          stockSede(idSede: $idSede) {
            cantidad
            enPrestamo
            stockMinimo
            sucursal {
              nombre
              administraStock
              sede {
                nombre
              }
            }
          }
        }
      }
    `
  );

  // Provisiones pendientes para calcular "stock pendiente de entrega"
  const [getPendientes, { data: dataPendientes }] = useLazyQuery(
    gql`
      query GET_PROVISIONES_PENDIENTES {
        provisiones(
          filter: { anulada: false, _pedidoCompra: { tipoDetalle: "Productos" } }
        ) {
          id
          detalles {
            id
            cantidad
            cantidadEntregada
            materiaPrima {
              id
            }
          }
        }
      }
    `,
    { fetchPolicy: "network-only" }
  );

  const [getTotalSede] = useLazyQuery(
    gql`
      query getProductos($order: Order, $filter: JSON) {
        materiasPrimas(order: $order, filter: $filter) {
          __typename @skip(if: true)
          id
          tipo
          nombre
          disabled
          categoria
          pendienteRecepcionar
          stockPorSede {
            sede {
              id
              nombre
            }
            cantidad
          }
        }
      }
    `
  );

  const [mutateProducto] = useMutation(gql`
    mutation saveDisabledMP($input: SaveDisabledMPInput!) {
      saveDisabledMP(input: $input) {
        id
      }
    }
  `);

  const [habilitarProducto] = useMutation(gql`
    mutation saveMateriaPrima($input: MateriaPrimaInput!) {
      saveMateriaPrima(input: $input) {
        id
      }
    }
  `);

  const handleSearch = (event) => {
    const newTimeout = setTimeout(() => {
      setSearch(event.target.value);
      setPage(1);
    }, 500);
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    setSearchTimeout(newTimeout);
  };

  const handleFilter = (event) => {
    const { name, value } = event.target;
    if (value == -1) {
      setFilter((prev) => {
        const updatedFilter = { ...prev };
        delete updatedFilter[name];
        return updatedFilter;
      });
    } else {
      setFilter((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleOpenMenu = (event, item) => {
    setSelectedItem(item);
    setOpenDetailDrawer(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenMenu(false);
    setOpenDetailDrawer(false);
  };

  const handleOpenProductoModal = () => {
    setOpenDetailDrawer(false);
    setOpenModalProducto(true);
  };

  const handleOpenAjusteModal = (tipoAjuste) => {
    setSelectedAjuste(tipoAjuste);
    setOpenDetailDrawer(false);
    setOpenModalAjuste(true);
  };

  const handleOpenTransferenciaModal = () => {
    setOpenDetailDrawer(false);
    setOpenModalTransferencia(true);
  };

  const handleOpenTransferenciaHistory = () => {
    setOpenDetailDrawer(false);
    setOpenModalTransferenciaHistory(true);
  };

  const handleOpenIngresarModal = () => {
    setOpenDetailDrawer(false);
    setOpenModalIngresar(true);
  };

  const handleOpenProductoComercial = () => {
    setOpenDetailDrawer(false);
    setOpenModalProdComercial(true);
  };

  const handleOrderBy = (campo) => {
    if (orderBy.campo === campo) {
      if (orderBy.orden === "ASC") {
        setOrderBy({
          campo: campo,
          orden: "DESC",
        });
      } else {
        setOrderBy({
          campo: campo,
          orden: "ASC",
        });
      }
    } else {
      setOrderBy({
        campo: campo,
        orden: "ASC",
      });
    }
  };

  const handleOpenAddMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenAddMenu(true);
  };

  const handleCloseAddMenu = () => {
    setAnchorEl(null);
    setOpenAddMenu(false);
  };

  const handleOpenAjusteMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenAjusteMenu(true);
  };

  const handleCloseAjusteMenu = () => {
    setAnchorEl(null);
    setOpenAjusteMenu(false);
  };

  const handleOpenSucursalMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenSucursalMenu(true);
  };

  const handleCloseSucursalMenu = () => {
    setAnchorEl(null);
    setOpenSucursalMenu(false);
  };

  const handleOpenModalConfirm = () => {
    setOpenDetailDrawer(false);
    let productosNombres = selectedItem?.ingredientes?.map((ingrediente) => ({ id: ingrediente?.producto?.id, nombre: ingrediente?.producto?.nombre }));
    if (productosNombres?.length > 0 && !selectedItem?.disabled) {
      setProductosNombres(productosNombres);
      setOpenModalShowProductos(true);
    } else {
      setOpenModalConfirm(true);
    }
  };

  const handleCloseModalConfirm = () => {
    setOpenModalConfirm(false);
  };

  const handleOpenIngresoMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenIngresoMenu(true);
  };

  const handleCloseIngresoMenu = () => {
    setAnchorEl(null);
    setOpenIngresoMenu(false);
  };

  const toggleFilters = () => {
    if (openFilters) {
      setOpenFilters(false);
    } else {
      setOpenFilters(true);
    }
  };

  const handleDisabled = (motivo) => {
    if (selectedItem?.disabled) {
      habilitarProducto({
        variables: {
          input: {
            id: selectedItem.id,
            disabled: false,
          },
        },
      })
        .then(() => {
          handleSnackbar("Producto habilitado correctamente", "success");
          refetch();
        })
        .catch((err) => {
          console.log('err--->', err);
          handleSnackbar("Ocurrió un error al habilitar la materia prima", "error");
        })
        .finally(() => {
          setOpenModalShowProductos(false);
          handleCloseMenu();
        });
    } else {
      mutateProducto({
        variables: {
          input: {
            idMateriaPrima: selectedItem.id,
            motivoBaja: motivo || null,
            idsProds: productosNombres?.map(p => p.id) || [],
          },
        },
      })
        .then(() => {
          handleSnackbar("Producto actualizado correctamente", "success");
          refetch();
        })
        .catch((err) => {
          console.log('err--->', err);
          handleSnackbar("Ocurrió un error al actualizar la materia prima", "error");
        })
        .finally(() => {
          setOpenModalShowProductos(false);
          handleCloseMenu();
        });
    }
  };

  // Cargar provisiones pendientes una vez al montar
  useEffect(() => {
    getPendientes();
  }, []);

  useEffect(
    () => () => {
      if (stockRefreshTimeoutRef.current) {
        clearTimeout(stockRefreshTimeoutRef.current);
      }
    },
    [stockRefreshTimeoutRef]
  );

  useEffect(() => {
    if (
      !nuevoPedidoStockEvent?.nuevoPedido &&
      !pedidoModificadoStockEvent?.pedidoModificado &&
      !pedidoEliminadoStockEvent?.pedidoEliminado
    ) {
      return;
    }

    if (stockRefreshTimeoutRef.current) return;

    stockRefreshTimeoutRef.current = setTimeout(() => {
      stockRefreshTimeoutRef.current = null;
      refetch();
    }, 250);
  }, [
    nuevoPedidoStockEvent,
    pedidoModificadoStockEvent,
    pedidoEliminadoStockEvent,
    refetch,
    stockRefreshTimeoutRef,
  ]);

  // Construir filas incorporando "pendienteRecepcionar" por materia prima
  useEffect(() => {
    if (data) {
      let productos = data?.materiasPrimas || [];
      // Mapear pendientes por MP sólo si ya tenemos provisiones
      if (dataPendientes?.provisiones) {
        const idsPagina = new Set(productos.map((mp) => mp.id));
        const pendientesMap = {};
        for (const prov of dataPendientes.provisiones || []) {
          for (const det of prov?.detalles || []) {
            const mpId = det?.materiaPrima?.id;
            if (!idsPagina.has(mpId)) continue;
            const pendiente = (det?.cantidad || 0) - (det?.cantidadEntregada || 0);
            if (pendiente > 0) pendientesMap[mpId] = (pendientesMap[mpId] || 0) + pendiente;
          }
        }
        productos = productos.map((mp) => ({
          ...mp,
          pendienteRecepcionar: pendientesMap[mp.id] || 0,
        }));
        if (onlyPendiente) {
          productos = productos.filter((mp) => (mp.pendienteRecepcionar || 0) > 0);
        }
      }
      setRows(getRows(productos, handleOpenMenu));
      setPagesInfo(data?.paginationInfo);
    }
  }, [data, dataPendientes, onlyPendiente]);

  const renderSucursalMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      open={Boolean(openSucursalMenu)}
      onClose={handleCloseSucursalMenu}
      transformOrigin={{ horizontal: "left", vertical: "top" }}
      anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
        },
      }}
    >
      {dataSucurales?.sucursales?.map((sucursal, index) => (
        <MenuItem
          key={index}
          onClick={() => {
            setSelectedSucursal(sucursal.id);
            handleCloseSucursalMenu();
          }}
        >
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: "100%",
            }}
          >
            <SoftBox mr={2}>
              <SoftTypography variant="p" fontWeight="medium">
                {sucursal.sede.nombre}
              </SoftTypography>
              <SoftTypography variant="p">{` - ${sucursal.nombre}`}</SoftTypography>
            </SoftBox>
            <SoftBox>
              <Icon
                fontSize="small"
                sx={{
                  verticalAlign: "middle",
                  color:
                    sucursal.id === selectedSucursal
                      ? getUproColor("uproPink")
                      : getUproColor("uproGreen"),
                }}
              >
                location_on
              </Icon>
            </SoftBox>
          </SoftBox>
        </MenuItem>
      ))}
    </Menu>
  );

  const renderAjusteMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      open={Boolean(openAjusteMenu)}
      onClose={handleCloseAjusteMenu}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
        },
      }}
    >
      <MenuItem
        onClick={() => {
          setOpenModalAjuste(true);
          setSelectedAjuste("Ajuste");
          handleCloseAjusteMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox>
            <SoftTypography variant="p">Ajuste</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproGreen"),
              }}
            >
              drive_file_rename_outline
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
      <MenuItem
        onClick={() => {
          setOpenModalAjuste(true);
          setSelectedAjuste("Merma");
          handleCloseAjusteMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox>
            <SoftTypography variant="p">Merma</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproPink"),
              }}
            >
              arrow_downward
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
      <MenuItem
        onClick={() => {
          setOpenModalAjusteHistory(true);
          handleCloseAjusteMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox>
            <SoftTypography variant="p">Ver historial</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproBlue"),
              }}
            >
              history
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
    </Menu>
  );

  const renderAddMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      open={Boolean(openAddMenu)}
      onClose={handleCloseAddMenu}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
        },
      }}
    >
      <Tooltip title="Elementos básicos de bajo valor patrimonial" placement="left">
        <MenuItem
          onClick={() => {
            setOpenModalProducto(true);
            setSelectedItem({ tipo: "Material" });
          }}
        >
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: "100%",
            }}
          >
            <SoftBox>
              <SoftTypography variant="p">Material</SoftTypography>
            </SoftBox>
            <SoftBox>
              <Icon
                fontSize="small"
                sx={{
                  verticalAlign: "middle",
                  color: getUproColor("uproYellow"),
                }}
              >
                category
              </Icon>
            </SoftBox>
          </SoftBox>
        </MenuItem>
      </Tooltip>
      <Tooltip title="Elementos que se agotan con el uso" placement="left">
        <MenuItem
          onClick={() => {
            setOpenModalProducto(true);
            setSelectedItem({ tipo: "Consumible" });
          }}
          sx={{
            minWidth: { xs: "75vw", sm: "auto" },
          }}
        >
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: "100%",
            }}
          >
            <SoftBox>
              <SoftTypography variant="p">Consumible</SoftTypography>
            </SoftBox>
            <SoftBox>
              <Icon
                fontSize="small"
                sx={{
                  verticalAlign: "middle",
                  color: getUproColor("uproGreen"),
                }}
              >
                recycling
              </Icon>
            </SoftBox>
          </SoftBox>
        </MenuItem>
      </Tooltip>
      <Tooltip
        title="Productos valiosos y específicos que requieren cuidado o mantenimiento"
        placement="left"
      >
        <MenuItem
          onClick={() => {
            setOpenModalProducto(true);
            setSelectedItem({ tipo: "Recurso" });
          }}
        >
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: "100%",
            }}
          >
            <SoftBox>
              <SoftTypography variant="p">Recurso</SoftTypography>
            </SoftBox>
            <SoftBox>
              <Icon
                fontSize="small"
                sx={{
                  verticalAlign: "middle",
                  color: getUproColor("uproPink"),
                }}
              >
                layers
              </Icon>
            </SoftBox>
          </SoftBox>
        </MenuItem>
      </Tooltip>
    </Menu>
  );

  const renderMenu = (
    <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(openMenu)} onClose={handleCloseMenu}>
      <MenuItem onClick={() => setOpenModalProducto(true)} disabled={false}>
        <Icon
          sx={{
            color: getUproColor("uproYellow"),
          }}
          fontSize="small"
        >
          edit
        </Icon>
        &nbsp;Editar
      </MenuItem>
      <MenuItem onClick={() => setOpenModalProductoMovimientos(true)} disabled={false}>
        <Icon
          sx={{
            color: getUproColor("uproBlue"),
          }}
          fontSize="small"
        >
          history
        </Icon>
        &nbsp;Últimos movimientos
      </MenuItem>
      <MenuItem onClick={() => setOpenModalProductoStock(true)} disabled={false}>
        <Icon
          sx={{
            color: getUproColor("uproGreen"),
          }}
          fontSize="small"
        >
          inventory
        </Icon>
        &nbsp;Stock en sucursales
      </MenuItem>
      <MenuItem onClick={handleOpenModalConfirm} disabled={false}>
        <Icon color={selectedItem?.disabled ? "success" : "error"} fontSize="small">
          {selectedItem?.disabled ? "arrow_upward_icon" : "arrow_downward_icon"}
        </Icon>
        &nbsp;{selectedItem?.disabled ? "Habilitar" : "Deshabilitar"}
      </MenuItem>
      {selectedItem && !selectedItem?.disabled && selectedItem?.stock?.cantidad > 0 && (<MenuItem onClick={() => setOpenModalProdComercial(true)} disabled={false}>
        <Icon
          sx={{
            color: getUproColor(),
          }}
          fontSize="small"
        >
          sell
        </Icon>
        &nbsp;Publicar como producto para la venta
      </MenuItem>)}
    </Menu>
  );

  const renderIngresoMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      open={Boolean(openIngresoMenu)}
      onClose={handleCloseIngresoMenu}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
        },
      }}
    >
      <MenuItem
        onClick={() => {
          setOpenModalNuevoRemito(true);
          handleCloseIngresoMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox mr={2}>
            <SoftTypography variant="p">Nuevo remito a proveedor</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproGreen"),
              }}
            >
              add
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
      <MenuItem
        onClick={() => {
          setOpenModalIngresar(true);
          handleCloseIngresoMenu();
        }}
        sx={{
          minWidth: { xs: "75vw", sm: "auto" },
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox mr={2}>
            <SoftTypography variant="p">Ver remitos a proveedores</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproBlue"),
              }}
            >
              history
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
    </Menu>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              display={{ xs: "flex-row", sm: "flex" }}
              justifyContent="space-between"
              alignItems="center"
              p={3}
              pb={{
                xs: 2,
                sm: 3,
              }}
            >
              <SoftBox pb={{ xs: 3, sm: 0 }} display="flex" justifyContent="space-between">
                <SoftBox
                  display="flex"
                  alignItems="center"
                  onClick={handleOpenSucursalMenu}
                  mr={{
                    xs: 2,
                    sm: 0,
                  }}
                >
                  <Icon color="primary">location_on</Icon>
                  <SoftTypography
                    variant="h6"
                    sx={{
                      cursor: "pointer",
                    }}
                    ml={1}
                  >
                    {loadingSucursales ? (
                      <Skeleton width={100} />
                    ) : dataSucurales?.sucursales?.find(
                      (sucursal) => sucursal.id === selectedSucursal
                    ) ? (
                      `${dataSucurales?.sucursales?.find(
                        (sucursal) => sucursal.id === selectedSucursal
                      )?.sede.nombre
                        } - ${dataSucurales?.sucursales?.find(
                          (sucursal) => sucursal.id === selectedSucursal
                        )?.nombre
                        } `.length > 50 ? (
                        `${dataSucurales?.sucursales?.find(
                          (sucursal) => sucursal.id === selectedSucursal
                        )?.sede.nombre
                          } - ${dataSucurales?.sucursales?.find(
                            (sucursal) => sucursal.id === selectedSucursal
                          )?.nombre
                          } `.substring(0, 50) + "..."
                      ) : (
                        `${dataSucurales?.sucursales?.find(
                          (sucursal) => sucursal.id === selectedSucursal
                        )?.sede.nombre
                        } - ${dataSucurales?.sucursales?.find(
                          (sucursal) => sucursal.id === selectedSucursal
                        )?.nombre
                        } `
                      )
                    ) : (
                      "No está asignado a ningún pañol"
                    )}
                  </SoftTypography>
                  <Icon color="dark">{openSucursalMenu ? "arrow_drop_up" : "arrow_drop_down"}</Icon>
                </SoftBox>
                <SoftBox
                  display={{
                    xs: "flex",
                    sm: "none",
                  }}
                  justifyContent="flex-end"
                >
                  <SoftBox mr={2}>
                    <Tooltip title={openFilters ? "Cerrar filtros" : "Ver filtros"} placement="top">
                      <SoftButton color="uproGreen" onClick={toggleFilters} circular iconOnly>
                        <Icon sx={{ fontWeight: "bold" }}>
                          {openFilters ? "filter_alt_off" : "filter_alt"}
                        </Icon>
                      </SoftButton>
                    </Tooltip>
                  </SoftBox>
                  <SoftBox>
                    <Tooltip title="Opciones" placement="top">
                      <SoftButton
                        color="primary"
                        onClick={() => setOpenModalOptions(true)}
                        circular
                        iconOnly
                      >
                        <Icon sx={{ fontWeight: "light" }}>more_vert</Icon>
                      </SoftButton>
                    </Tooltip>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
              <SoftBox
                display={{ xs: "flex-row", sm: "flex" }}
                justifyContent="end"
                alignItems="flex-end"
              >
                <SoftBox
                  mr={{
                    xs: 0,
                    sm: 2,
                  }}
                >
                  <SoftInput
                    placeholder="Escribe aquí..."
                    icon={{ component: "search", direction: "left" }}
                    onChange={handleSearch}
                  />
                </SoftBox>
                {/* <SoftBox mr={2} display={{ xs: "none", sm: "block" }}>
                  <Tooltip title="Stock inicial rápido" placement="top">
                    <SoftButton
                      color="uproGreen"
                      circular
                      iconOnly
                      onClick={() => setOpenModalStockRapido(true)}
                    >
                      <Icon sx={{ fontWeight: "light" }}>electric_bolt</Icon>
                    </SoftButton>
                  </Tooltip>
                </SoftBox> */}
                {/* <SoftBox
                  mr={2}
                  display={{
                    xs: "none",
                    sm: "block",
                  }}
                >
                  <Tooltip title="Administrar proveedores" placement="top"><span>
                    <SoftButton
                      color="uproYellow"
                      onClick={() => setOpenModalProveedores(true)}
                      circular
                      iconOnly
                      disabled={!selectedSucursal}
                    >
                      <Icon sx={{ fontWeight: "light" }}>people_alt</Icon>
                    </SoftButton>
                  </span></Tooltip>
                </SoftBox> */}
                <SoftBox
                  mr={2}
                  display={{
                    xs: "none",
                    sm: "block",
                  }}
                >
                  <Tooltip title="Ingresar productos" placement="top"><span>
                    <SoftButton
                      color="uproYellow"
                      onClick={handleOpenIngresoMenu}
                      circular
                      iconOnly
                      disabled={!selectedSucursal}
                    >
                      <Icon sx={{ fontWeight: "light" }}>local_shipping</Icon>
                    </SoftButton>
                  </span></Tooltip>
                </SoftBox>
                <SoftBox mt={2} display={{ xs: "block", sm: "none" }}>
                  <Tooltip title="Stock inicial rápido" placement="top">
                    <SoftButton
                      color="uproGreen"
                      circular
                      fullWidth
                      onClick={() => setOpenModalStockRapido(true)}
                    >
                      <Icon sx={{ fontWeight: "light" }}>electric_bolt</Icon>
                      &nbsp;Stock rápido
                    </SoftButton>
                  </Tooltip>
                </SoftBox>
                <SoftBox
                  mr={2}
                  display={{
                    xs: "none",
                    sm: "block",
                  }}
                >
                  <Tooltip title="Transferencias y prestamos" placement="top"><span>
                    <SoftButton
                      color="uproYellow"
                      onClick={(event) => {
                        menu({
                          open: event.currentTarget,
                          align: "right",
                          options: [
                            {
                              name: "Nueva transferencia",
                              icon: { icon: "import_export", color: getUproColor("uproGreen") },
                              onClick: () => {
                                setOpenModalTransferencia(true);
                              },
                            },
                            {
                              name: "Ver historial",
                              icon: { icon: "history", color: getUproColor("uproBlue") },
                              onClick: () => {
                                setOpenModalTransferenciaHistory(true);
                              },
                            },
                          ],
                        });
                      }}
                      circular
                      iconOnly
                      disabled={!selectedSucursal}
                    >
                      <Icon sx={{ fontWeight: "light" }}>import_export</Icon>
                    </SoftButton>
                  </span></Tooltip>
                </SoftBox>

                <SoftBox
                  mr={2}
                  display={{
                    xs: "none",
                    sm: "block",
                  }}
                >
                  <Tooltip title="Ajustar stock" placement="top"><span>
                    <SoftButton
                      color="uproYellow"
                      onClick={handleOpenAjusteMenu}
                      circular
                      iconOnly
                      disabled={!selectedSucursal}
                    >
                      <Icon sx={{ fontWeight: "light" }}>drive_file_rename_outline</Icon>
                    </SoftButton>
                  </span></Tooltip>
                </SoftBox>
                <SoftBox
                  mr={2}
                  display={{
                    xs: "none",
                    sm: "block",
                  }}
                >
                  <Tooltip title="Agregar nueva materia prima" placement="top"><span>
                    <SoftButton
                      color="primary"
                      onClick={handleOpenAddMenu}
                      disabled={!selectedSucursal}
                      circular
                    >
                      <Icon>add</Icon>
                      &nbsp;Agregar
                    </SoftButton>
                  </span></Tooltip>
                </SoftBox>
                <SoftBox
                  display={{
                    xs: "none",
                    sm: "block",
                  }}
                >
                  <Tooltip title={openFilters ? "Cerrar filtros" : "Ver filtros"} placement="top">
                    <SoftButton color="uproGreen" onClick={toggleFilters} circular iconOnly>
                      <Icon sx={{ fontWeight: "bold" }}>
                        {openFilters ? "filter_alt_off" : "filter_alt"}
                      </Icon>
                    </SoftButton>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <Collapse in={openFilters} timeout="auto" unmountOnExit>
              <SoftBox
                display="flex"
                flexDirection={{
                  xs: "column",
                  sm: "row",
                }}
                justifyContent="end"
                alignItems="center"
                px={3}
                pb={3}
                gap={2}
              >
                <Select
                  name="tipo"
                  value={filter?.["tipo"] || -1}
                  sx={{
                    paddingRight: "35px !important",
                  }}
                  onChange={handleFilter}
                >
                  <MenuItem value={-1}>
                    <SoftBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        width: "100%",
                      }}
                    >
                      <SoftBox>
                        <SoftTypography variant="p">Todos</SoftTypography>
                      </SoftBox>
                      <SoftBox>
                        <Icon
                          fontSize="small"
                          sx={{
                            verticalAlign: "middle",
                            color: getUproColor("uproBlue"),
                          }}
                        >
                          dataset
                        </Icon>
                      </SoftBox>
                    </SoftBox>
                  </MenuItem>
                  <MenuItem value="Material">
                    <SoftBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        width: "100%",
                      }}
                    >
                      <SoftBox>
                        <SoftTypography variant="p">Materiales</SoftTypography>
                      </SoftBox>
                      <SoftBox>
                        <Icon
                          fontSize="small"
                          sx={{
                            verticalAlign: "middle",
                            color: getUproColor("uproYellow"),
                          }}
                        >
                          category
                        </Icon>
                      </SoftBox>
                    </SoftBox>
                  </MenuItem>
                  <MenuItem
                    value="Consumible"
                    sx={{
                      minWidth: { xs: "70vw", sm: "auto" },
                    }}
                  >
                    <SoftBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        width: "100%",
                      }}
                    >
                      <SoftBox>
                        <SoftTypography variant="p">Consumibles</SoftTypography>
                      </SoftBox>
                      <SoftBox>
                        <Icon
                          fontSize="small"
                          sx={{
                            verticalAlign: "middle",
                            color: getUproColor("uproGreen"),
                          }}
                        >
                          recycling
                        </Icon>
                      </SoftBox>
                    </SoftBox>
                  </MenuItem>
                  <MenuItem value="Recurso">
                    <SoftBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        width: "100%",
                      }}
                    >
                      <SoftBox>
                        <SoftTypography variant="p">Recursos</SoftTypography>
                      </SoftBox>
                      <SoftBox>
                        <Icon
                          fontSize="small"
                          sx={{
                            verticalAlign: "middle",
                            color: getUproColor("uproPink"),
                          }}
                        >
                          layers
                        </Icon>
                      </SoftBox>
                    </SoftBox>
                  </MenuItem>
                </Select>
                <Select
                  name="categoria"
                  value={filter?.["categoria"] != undefined ? filter?.["categoria"] : -1}
                  onChange={handleFilter}
                >
                  <MenuItem value={-1}>No filtrar por categoria</MenuItem>
                  {dataCategorias?.categoriasMateriaPrima?.map((categoria, index) => (
                    <MenuItem key={index} value={categoria.nombre}>
                      {categoria.nombre}
                    </MenuItem>
                  ))}
                </Select>
                <Select
                  name="_stock"
                  defaultValue={0}
                  onChange={(e) => {
                    let value = e.target.value;
                    // Filtro backend por pendiente de recibir
                    if (value == 3) {
                      setOnlyPendiente(false);
                      handleFilter({ target: { name: "_pendienteRecepcionar", value: true } });
                    } else {
                      handleFilter({ target: { name: "_pendienteRecepcionar", value: -1 } });
                    }
                    handleFilter({
                      target: {
                        name: "_stock",
                        value:
                          value == 1
                            ? { cantidad: { _gte: 1 }, idSucursal: selectedSucursal }
                            : value == 2
                              ? {
                                cantidad: { _lte: { _col: "stockMinimo" } },
                                idSucursal: selectedSucursal,
                              }
                              : -1,
                      },
                    });
                  }}
                >
                  <MenuItem value={0}>No filtrar por stock</MenuItem>
                  <MenuItem value={1}>Con stock</MenuItem>
                  <MenuItem value={2}>Stock crítico</MenuItem>
                  <MenuItem value={3}>Pendiente de recibir</MenuItem>
                </Select>
                <Select
                  name="disabled"
                  value={filter?.["disabled"] != undefined ? filter?.["disabled"] : -1}
                  onChange={handleFilter}
                >
                  <MenuItem value={-1}>Todos los estados</MenuItem>
                  <MenuItem value={false}>Habilitados</MenuItem>
                  <MenuItem value={true}>Deshabilitados</MenuItem>
                </Select>
                <SoftBox>
                  <Tooltip title="Descargar listado de productos en excel" placement="top">
                    <SoftButton
                      color="success"
                      circular
                      sx={{
                        textWrap: "nowrap",
                      }}
                      onClick={(event) => {
                        menu({
                          open: event.currentTarget,
                          align: "right",
                          options: [
                            {
                              name: "Esta sucursal",
                              icon: { icon: "place", color: "primary" },
                              onClick: () => {
                                getProductosData({
                                  variables: {
                                    order: { field: orderBy.campo, order: orderBy.orden },
                                    filter: filter,
                                    idSucursal: selectedSucursal,
                                  },
                                }).then((data) => {
                                  let productosExportar = data?.data?.materiasPrimas;
                                  let sucursal = dataSucurales?.sucursales?.find(
                                    (sucursal) => sucursal.id === selectedSucursal
                                  );

                                  productosExportar = productosExportar.map((materiaPrima) => {
                                    return {
                                      ID: materiaPrima.id,
                                      Tipo: materiaPrima.tipo,
                                      Nombre: materiaPrima.nombre,
                                      Categoria: materiaPrima.categoria,
                                      Stock: materiaPrima.stock?.cantidad || 0,
                                      "Stock Minimo": materiaPrima.stock?.stockMinimo || 0,
                                      "En prestamo": materiaPrima.stock?.enPrestamo || 0,
                                      Deshabilitado: materiaPrima.disabled ? "Si" : "No",
                                    };
                                  });

                                  const cabecera = [
                                    [
                                      `Productos ${sucursal?.sede?.nombre} - ${sucursal?.nombre
                                      } - ${dayjs().format("DD-MM-YYYY")} `,
                                    ],
                                  ];

                                  const sheet = XLSX.utils.aoa_to_sheet(cabecera);

                                  XLSX.utils.sheet_add_json(sheet, productosExportar, {
                                    skipHeader: false,
                                    origin: -1,
                                  });

                                  sheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];

                                  const workbook = XLSX.utils.book_new();
                                  XLSX.utils.book_append_sheet(
                                    workbook,
                                    sheet,
                                    `Stock ${dayjs().format("DD-MM-YYYY")} `
                                  );

                                  XLSX.writeFile(
                                    workbook,
                                    `Productos ${sucursal?.sede?.nombre} - ${sucursal?.nombre
                                    } - ${dayjs().format("DD-MM-YYYY")}.xlsx`
                                  );
                                });
                              },
                            },
                            {
                              name: "Toda esta sede",
                              icon: { icon: "location_city", color: getUproColor("uproYellow") },
                              onClick: () => {
                                getProductosSede({
                                  variables: {
                                    order: { field: orderBy.campo, order: orderBy.orden },
                                    filter: filter,
                                    idSede: dataSucurales?.sucursales?.find(
                                      (sucursal) => sucursal.id === selectedSucursal
                                    )?.sede.id,
                                  },
                                }).then((data) => {
                                  let productosExportar = data?.data?.materiasPrimas;
                                  let sucursal = dataSucurales?.sucursales?.find(
                                    (sucursal) => sucursal.id === selectedSucursal
                                  );

                                  // Obtener todas las columnas de stock posibles
                                  let columnasStock = new Set();
                                  productosExportar.forEach((materiaPrima) => {
                                    materiaPrima.stockSede.forEach((sucursal) => {
                                      columnasStock.add(`Stock ${sucursal.sucursal.nombre} `);
                                    });
                                  });

                                  // Convertir el conjunto a un array para ordenarlas
                                  columnasStock = Array.from(columnasStock).sort();

                                  // Procesar los productos para asegurar que cada uno tenga todas las columnas de stock
                                  productosExportar = productosExportar.map((materiaPrima) => {
                                    let thisProducto = {
                                      ID: materiaPrima.id,
                                      Tipo: materiaPrima.tipo,
                                      Nombre: materiaPrima.nombre,
                                      Categoria: materiaPrima.categoria,
                                      Deshabilitado: materiaPrima.disabled ? "Si" : "No",
                                    };

                                    // Inicializar todas las columnas de stock en 0
                                    columnasStock.forEach((columna) => {
                                      thisProducto[columna] = 0;
                                    });

                                    // Rellenar las columnas de stock con los valores correspondientes
                                    materiaPrima.stockSede.forEach((sucursal) => {
                                      thisProducto[`Stock ${sucursal.sucursal.nombre} `] =
                                        sucursal.cantidad || 0;
                                    });

                                    return thisProducto;
                                  });

                                  const cabecera = [
                                    [
                                      `Productos en sede ${sucursal?.sede?.nombre
                                      } - ${dayjs().format("DD-MM-YYYY")} `,
                                    ],
                                  ];

                                  const sheet = XLSX.utils.aoa_to_sheet(cabecera);

                                  XLSX.utils.sheet_add_json(sheet, productosExportar, {
                                    skipHeader: false,
                                    origin: -1,
                                  });

                                  // Asegurarse de combinar las celdas adecuadas en la cabecera
                                  sheet["!merges"] = [
                                    { s: { r: 0, c: 0 }, e: { r: 0, c: columnasStock.length + 4 } },
                                  ];

                                  const workbook = XLSX.utils.book_new();
                                  XLSX.utils.book_append_sheet(
                                    workbook,
                                    sheet,
                                    `Stock ${dayjs().format("DD-MM-YYYY")} `
                                  );

                                  XLSX.writeFile(
                                    workbook,
                                    `Productos sede ${sucursal?.sede?.nombre} - ${dayjs().format(
                                      "DD-MM-YYYY"
                                    )
                                    }.xlsx`
                                  );
                                });
                              },
                            },
                            {
                              name: "Total por sede",
                              icon: { icon: "assessment", color: getUproColor("uproGreen") },
                              onClick: () => {
                                getTotalSede({
                                  variables: {
                                    order: { field: orderBy.campo, order: orderBy.orden },
                                    // mandar el filtro sin la propiedad _stock
                                    filter: Object.keys(filter).reduce((acc, key) => {
                                      if (key !== "_stock") {
                                        acc[key] = filter[key];
                                      }
                                      return acc;
                                    }, {}),
                                  },
                                }).then((data) => {
                                  let productosExportar = data?.data?.materiasPrimas;

                                  // Obtener todas las columnas de stock posibles
                                  let columnasStock = new Set();
                                  productosExportar.forEach((materiaPrima) => {
                                    materiaPrima.stockPorSede.forEach((sede) => {
                                      columnasStock.add(`Stock ${sede.sede.nombre} `);
                                    });
                                  });

                                  // Convertir el conjunto a un array para ordenarlas
                                  columnasStock = Array.from(columnasStock).sort();

                                  // Procesar los productos para asegurar que cada uno tenga todas las columnas de stock
                                  productosExportar = productosExportar.map((materiaPrima) => {
                                    let thisProducto = {
                                      ID: materiaPrima.id,
                                      Tipo: materiaPrima.tipo,
                                      Nombre: materiaPrima.nombre,
                                      Categoria: materiaPrima.categoria,
                                      Deshabilitado: materiaPrima.disabled ? "Si" : "No",
                                    };

                                    // Inicializar todas las columnas de stock en 0
                                    columnasStock.forEach((columna) => {
                                      thisProducto[columna] = 0;
                                    });

                                    // Rellenar las columnas de stock con los valores correspondientes
                                    materiaPrima.stockPorSede.forEach((sucursal) => {
                                      thisProducto[`Stock ${sucursal.sede.nombre} `] =
                                        sucursal.cantidad || 0;
                                    });

                                    return thisProducto;
                                  });

                                  const cabecera = [
                                    [`Stock efectivo por sede - ${dayjs().format("DD-MM-YYYY")} `],
                                  ];

                                  const sheet = XLSX.utils.aoa_to_sheet(cabecera);

                                  XLSX.utils.sheet_add_json(sheet, productosExportar, {
                                    skipHeader: false,
                                    origin: -1,
                                  });

                                  // Asegurarse de combinar las celdas adecuadas en la cabecera
                                  sheet["!merges"] = [
                                    { s: { r: 0, c: 0 }, e: { r: 0, c: columnasStock.length + 4 } },
                                  ];

                                  const workbook = XLSX.utils.book_new();
                                  XLSX.utils.book_append_sheet(
                                    workbook,
                                    sheet,
                                    `Stock ${dayjs().format("DD-MM-YYYY")} `
                                  );

                                  XLSX.writeFile(
                                    workbook,
                                    `Productos por sede - ${dayjs().format("DD-MM-YYYY")}.xlsx`
                                  );
                                });
                              },
                            },
                          ],
                          handleClose: () => { },
                        });
                      }}
                    >
                      <Icon>download</Icon>
                      &nbsp; Excel
                    </SoftButton>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </Collapse>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor} `,
                  },
                },
              }}
            >
              {loading ? (
                <Loading />
              ) : rows?.length > 0 && selectedSucursal ? (
                <DataTable columns={columns} rows={rows} order={orderBy} setOrder={handleOrderBy} />
              ) : (
                <SinDatos />
              )}
            </SoftBox>
            <CustomPagination
              loading={loading}
              length={data?.materiasPrimas.length}
              total={pagesInfo?.total}
              pages={pagesInfo?.pages}
              page={page}
              setPage={setPage}
              noCard
            />
          </Card>
          {renderAjusteMenu}
          {renderAddMenu}
          {renderMenu}
          {renderIngresoMenu}
          {renderSucursalMenu}
        </SoftBox>
      </SoftBox>

      <ModalConfirm
        open={openModalConfirm}
        handleClose={handleCloseModalConfirm}
        message={
          selectedItem?.disabled
            ? `¿Está seguro que desea habilitar la materia prima ? `
            : `¿Está seguro que desea deshabilitar la materia prima ? ` +
            `No estará disponible para nuevos pedidos y ordenes de compra.`
        }
        func={handleDisabled}
        pedirMotivo={!selectedItem?.disabled}
      />
      <DrawerProductoDetalle
        open={openDetailDrawer}
        handleClose={handleCloseMenu}
        item={selectedItem}
        idSucursal={selectedSucursal}
        idSede={dataSucurales?.sucursales?.find((s) => s.id === selectedSucursal)?.sede.id}
        onEdit={handleOpenProductoModal}
        onAjuste={() => handleOpenAjusteModal("Ajuste")}
        onMerma={() => handleOpenAjusteModal("Merma")}
        onTransferencia={handleOpenTransferenciaModal}
        onTransferHistory={handleOpenTransferenciaHistory}
        onIngresar={handleOpenIngresarModal}
        onToggleEnabled={handleOpenModalConfirm}
        onPublicar={handleOpenProductoComercial}
      />
      <ModalProducto
        id={selectedItem?.id || null}
        idSucursal={selectedSucursal || null}
        tipo={selectedItem?.tipo || null}
        open={openModalProducto}
        handleClose={() => {
          setOpenModalProducto(false);
        }}
        refetch={() => {
          refetch();
          handleCloseMenu();
          handleCloseAddMenu();
        }}
      />
      <ModalProductoMovimientos
        open={openModalProductoMovimientos}
        handleClose={() => {
          setOpenModalProductoMovimientos(false);
          handleCloseMenu();
        }}
        idProducto={selectedItem?.id}
        idSucursal={selectedSucursal}
      />
      <ModalProductoStock
        open={openModalProductoStock}
        handleClose={() => {
          setOpenModalProductoStock(false);
          handleCloseMenu();
        }}
        idProducto={selectedItem?.id}
        idSede={dataSucurales?.sucursales?.find((s) => s.id === selectedSucursal)?.sede.id}
      />
      <ModalAjuste
        open={openModalAjuste}
        handleClose={() => setOpenModalAjuste(false)}
        selectedAjuste={selectedAjuste}
        idSucursal={selectedSucursal}
        refetchProductos={refetch}
      />
      <ModalAjusteHistory
        open={openModalAjusteHistory}
        handleClose={() => setOpenModalAjusteHistory(false)}
        idSucursal={selectedSucursal}
        refetchProductos={refetch}
      />
      <ModalNuevoRemito
        open={openModalNuevoRemito}
        handleClose={() => {
          setOpenModalNuevoRemito(false);
        }}
        idSucursal={selectedSucursal}
        refetchProductos={refetch}
      />
      <ModalIngresar
        open={openModalIngresar}
        handleClose={() => setOpenModalIngresar(false)}
        idSucursal={selectedSucursal}
        refetchProductos={refetch}
      />
      <ModalOptions
        open={openModalOptions}
        handleClose={() => setOpenModalOptions(false)}
        options={[
          {
            title: "Stock inicial rápido",
            icon: "electric_bolt",
            onClick: () => setOpenModalStockRapido(true),
            color: "uproGreen",
          },
          {
            title: "Ajustar stock",
            icon: "drive_file_rename_outline",
            onClick: (e) => handleOpenAjusteMenu(e),
            color: "uproYellow",
          },
          {
            title: "Ingresar productos",
            icon: "local_shipping",
            onClick: (e) => handleOpenIngresoMenu(e),
            color: "uproYellow",
          },
          // {
          //   title: "Administrar proveedores",
          //   icon: "people_alt",
          //   onClick: () => setOpenModalProveedores(true),
          //   color: "uproYellow",
          // },
          {
            title: "Agregar nueva materia prima",
            icon: "add",
            onClick: (e) => handleOpenAddMenu(e),
            color: "primary",
          },
        ]}
      />
      <ModalStockRapido
        open={openModalStockRapido}
        handleClose={() => setOpenModalStockRapido(false)}
        idSucursal={selectedSucursal}
        refetch={refetch}
      />
      <ModalProveedores
        open={openModalProveedores}
        handleClose={() => setOpenModalProveedores(false)}
      />
      <ModalNuevaTransferencia
        open={openModalTransferencia}
        handleClose={() => setOpenModalTransferencia(false)}
        origen={dataSucurales?.sucursales?.find((s) => s.id === selectedSucursal)}
        refetch={refetch}
      />
      <ModalHistorialTransferencias
        open={openModalTransferenciaHistory}
        handleClose={() => setOpenModalTransferenciaHistory(false)}
        idSucursal={selectedSucursal}
        sucursal={dataSucurales?.sucursales?.find((s) => s.id === selectedSucursal)}
        refetchProductos={refetch}
      />
      <ModalProductoComercial
        refetch={refetch}
        open={openModalProdComercial}
        selectedItem={selectedItem}
        handleClose={() => {
          handleCloseMenu();
          setOpenModalProdComercial(false);
          setSelectedItem(null);
        }}
        categorias={[]}
      />
      <Modal
        aria-labelledby="modal-precio-cambio-title"
        aria-describedby="modal-precio-cambio-description"
        open={openModalShowProductos}
        onClose={() => setOpenModalShowProductos(false)}
        sx={{ width: "100%" }}
        closeAfterTransition
      >
        <Fade in={openModalShowProductos}>
          <Card sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: '25%',
            p: 3,
          }}>
            <SoftBox display="flex" gap={1} alignItems="center" mb={2}>
              <Icon fontSize="medium" color="warning">warning</Icon>
              <SoftTypography variant="h6">
                {`Deshabilitar: ${selectedItem?.nombre} `}
              </SoftTypography>
            </SoftBox>
            <SoftTypography variant="body2" mb={2}>
              Productos cuyos ingredientes contienen la materia prima que deseas deshabilitar
            </SoftTypography>
            <SoftTypography
              variant="caption"
              mb={2}
              px={.5}
              sx={{
                backgroundColor: '#f5ecd7',
                borderRadius: 2,
                padding: '8px 12px',
                border: '1px solid #e0d6c3',
                display: 'inline-block',
              }}
            >
              Los siguientes productos contienen la materia prima que deseas deshabilitar. Si continúas, estos productos serán deshabilitados y no estarán disponibles.
            </SoftTypography>
            <SoftBox mb={2}>
              <Table
                columns={[{ name: "nombre", desc: "Producto", align: "center", width: "100%" }]}
                rows={(productosNombres || []).map((item) => ({
                  nombre: (
                    <SoftTypography
                      verticalAlign="text-top"
                      variant="button"
                      color="dark"
                      fontWeight="bold"
                      title={item.nombre}
                    >
                      {item.nombre}
                    </SoftTypography>
                  )
                })
                )}
              />
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" gap={2} mt={2}>
              <SoftButton
                variant="gradient"
                color="secondary"
                onClick={() => setOpenModalShowProductos(false)}
                circular
                fullWidth
              >
                <Icon>undo</Icon>&nbsp;Volver
              </SoftButton>
              <SoftButton
                variant="gradient"
                color="uproGreen"
                onClick={() => setOpenModalConfirm(true)}
                circular
                fullWidth
              >
                <Icon>arrow_forward</Icon>&nbsp;Continuar
              </SoftButton>
            </SoftBox>
          </Card>
        </Fade>
      </Modal>
      <Footer />
    </DashboardLayout>
  );
}

export default Productos;
